import { CommissionType } from 'src/features/finance/commissionStatement/constants/commissionType';
import { enumToCamelCase } from 'src/lib/formatters';

export const getCommissionTypeHeading = (commissionType: string | undefined): string => {
    let headingType = enumToCamelCase(CommissionType.TRANSACTIONAL);

    if (commissionType) {
        const lowerCommissionType = commissionType.toLowerCase();
        if (lowerCommissionType === CommissionType.TERMINAL.toLowerCase()) {
            headingType = enumToCamelCase(CommissionType.TERMINAL);
        } else if (lowerCommissionType === CommissionType.ONLINE.toLowerCase()) {
            headingType = enumToCamelCase(CommissionType.ONLINE);
        }
    }

    return headingType;
};

export default getCommissionTypeHeading;
